import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith('http') || req.url.startsWith('https')) {
      return next.handle(req);
    }
    const requestWithUpdatedUrl = req.clone({url: environment.baseUrl + req.url});
    return next.handle(requestWithUpdatedUrl);
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/http/baseurl.interceptor.ts